import React, { useState, useEffect } from 'react';
import {
    Grid,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    InputLabel,
    OutlinedInput,
    Select,
    MenuItem,
    FormControl,
    Typography,
    Checkbox,
    FormControlLabel
} from '@mui/material';
import moment from 'moment';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { validateNumber } from 'utils/commonHelpers';
import ApiHelper from 'utils/apiHelper';
import { API_URL } from 'utils/constants';

const RightClickOptionsDialog = ({ onClose, option, devices, inputFields }) => {
    const navigate = useNavigate();
    const [textValue, setTextValue] = useState('');
    const [warningTime, setWarningTime] = useState(0);
    const [showWarningTime, setShowWarningTime] = useState(false);
    const [dialogTitle, setDialogTitle] = useState('');
    const [labelText, setLabelText] = useState('');
    const defaultStartDate = moment().subtract(15, 'days').format('YYYY-MM-DD');
    const maxDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
    const [startDate, setStartDate] = useState(defaultStartDate);
    const [endDate, setEndDate] = useState(maxDate);
    const [overrideSetBaseLine, setOverrideSetBaseLine] = useState(false);

    const [optionsData, setOptionsData] = useState([]);
    const [optionId, setOptionId] = useState('0');
    const [defaultOption, setDefaultOption] = useState('0');
    const [scriptList, setScriptList] = useState([]);

    const handleChangeWarningTime = (e) => {
        if (validateNumber(e.target.value, 'integer') === true) {
            setWarningTime(e.target.value);
        } else {
            toast.error('The warning time should be an integer.');
        }
    };

    const getPoliciesData = () => {
        ApiHelper.get(API_URL.MANAGEMENT_POLICY)
            .then((res) => {
                setOptionsData(res.data.policy_data);
            })
            .catch(() => {
                toast.error('Failed to get the policy data.');
            });
    };

    const getGroupsData = () => {
        ApiHelper.get(API_URL.MANAGEMENT_GROUPS)
            .then((res) => {
                setOptionsData(res.data.groups_results);
            })
            .catch(() => {
                toast.error('Failed to get the groups data.');
            });
    };

    const getScriptList = () => {
        ApiHelper.get(API_URL.MANAGEMENT_SCRIPTS)
            .then((res) => {
                setOptionsData(res.data.script_list);
            })
            .catch(() => {
                setOptionsData([]);
            });
    };
    const getUpgradeOptions = () => {
        ApiHelper.get('/api/settings/constants/', {}, {}, { values: 'upgrade_options' }).then((res) => {
            setOptionsData(res.data['upgradeOptions']);
        });
    };

    const getLicenseOptions = () => {
        ApiHelper.get('/api/settings/constants/', {}, {}, { values: 'license_options' }).then((res) => {
            setOptionsData(res.data['licenseOptions']);
        });
    };

    useEffect(() => {
        let deviceName = 'Device';
        if (devices.length > 1) {
            deviceName = 'Devices';
        }
        if (option === 'wake') {
            setDialogTitle(`Wake Selected ${deviceName}`);
            setLabelText('Reason for Action');
            setTextValue('Ad Hoc');
        } else if (option === 'sleep') {
            setDialogTitle(`Put ${deviceName} To Sleep`);
            setTextValue('Putting your device to sleep to save energy.');
            setShowWarningTime(true);
        } else if (option === 'restart') {
            setDialogTitle(`Restart Selected ${deviceName}`);
            setTextValue('Restart to save energy!');
            setShowWarningTime(true);
        } else if (option === 'shutdown') {
            setDialogTitle(`Shutdown Selected ${deviceName}`);
            setTextValue('Shutting down to save energy!');
            setShowWarningTime(true);
        } else if (option === 'group') {
            getGroupsData();
            setDialogTitle(`Group Selected ${deviceName}`);
            setLabelText('Group');
        } else if (option === 'policy') {
            getPoliciesData();
            setDialogTitle(`Policy Selected ${deviceName}`);
            setLabelText('Policy');
        } else if (option === 'label') {
            setDialogTitle(`${deviceName} Client Label`);
            setLabelText('Label');
        } else if (option === 'setBaseline') {
            setDialogTitle(`Set Baseline For Selected ${deviceName}`);
        } else if (option === 'getLogFile') {
            setDialogTitle('Get Client Log Files');
        } else if (option === 'upgrade') {
            setDialogTitle(`Upgrade Selection For Selected ${deviceName}`);
            setLabelText('Upgrade');
            getUpgradeOptions();
        } else if (option === 'license') {
            setDialogTitle(`License Selection For Selected ${deviceName}`);
            setLabelText('License');
            getLicenseOptions();
        } else if (option === 'getTISData') {
            setDialogTitle('Get TIS Data');
        } else if (option === 'script') {
            getScriptList();
            setDialogTitle(`Run Script for Selected ${deviceName}`);
            setLabelText('Script');
        }
    }, [option, devices]);

    const onSubmit = () => {
        let value;
        console.log('onSubmit ', option, textValue);
        if (option === 'upgrade' || option === 'license') {
            value = defaultOption;
        } else if (option === 'group' || option === 'policy' || option === 'script') {
            value = optionId;
        } else if (option === 'setBaseline') {
            value = {
                start_date: startDate,
                end_date: endDate,
                override: overrideSetBaseLine
            };
        } else if (option === 'getLogFile' || option === 'getTISData') {
            value = true;
        } else {
            value = textValue;
        }
        ApiHelper.post(API_URL.MANAGEMENT_ADHOC, {
            value: value,
            devices: devices,
            action: option
        })
            .then((res) => {
                if (option === 'getTISData') {
                    localStorage.setItem('devicesTISData', JSON.stringify(res.data));
                    navigate('/management/devices/show_tis_data');
                } else {
                    toast.success('Successfully done');
                }
                onClose(false);
            })
            .catch((err) => {
                if (err.response.data.message) {
                    toast.error(`Fail! ${err.response.data.message}`);
                } else {
                    toast.error('Failed to save');
                }
                onClose(false);
            });
    };

    const handleChangeValue = (e) => {
        // console.log(inputFields['value']);
        // if (e.target.value.length > inputFields['value']) {
        //     toast.warning('This field must be ' + inputFields['value'] + ' characters or less.');
        // } else {
        setTextValue(e.target.value);
        // }
    };

    return (
        <Dialog open={true} onClose={onClose}>
            <DialogTitle sx={{ fontSize: '18px' }}>{dialogTitle}</DialogTitle>
            <DialogContent sx={{ minWidth: '500px' }}>
                <Grid container spacing={1}>
                    {showWarningTime && (
                        <>
                            <Grid item sx={{ width: '100%' }}>
                                <InputLabel>Message for users</InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={textValue} onChange={(e) => handleChangeValue(e)} />
                            </Grid>
                            <Grid item sx={{ width: '100%', mt: 2 }}>
                                <InputLabel>Warning time (minutes)</InputLabel>
                                <OutlinedInput sx={{ width: '100%' }} value={warningTime} onChange={handleChangeWarningTime} />
                            </Grid>
                        </>
                    )}
                    {option === 'setBaseline' && (
                        <>
                            <Grid item xs={6} sx={{ mt: 2 }}>
                                <Typography>Start Date</Typography>
                                <input
                                    type="date"
                                    style={{ width: '100%', padding: 3, fontSize: '16px' }}
                                    value={startDate}
                                    max={maxDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={6} sx={{ mt: 2 }}>
                                <Typography>End Date</Typography>
                                <input
                                    type="date"
                                    style={{ width: '100%', padding: 3, fontSize: '16px' }}
                                    value={endDate}
                                    max={maxDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{ width: '100%', mt: 2 }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={overrideSetBaseLine}
                                            onChange={(e) => setOverrideSetBaseLine(e.target.checked)}
                                        />
                                    }
                                    label="Override old baseline?"
                                />
                            </Grid>
                        </>
                    )}
                    {(option === 'wake' || option === 'message' || option === 'label' || option === 'rename') && (
                        <Grid item sx={{ width: '100%' }}>
                            <InputLabel>{labelText}</InputLabel>
                            <OutlinedInput sx={{ width: '100%' }} value={textValue} onChange={(e) => handleChangeValue(e)} />
                        </Grid>
                    )}
                    {option === 'group' && (
                        <Grid item sx={{ width: '100%', mt: 1 }}>
                            <FormControl sx={{ width: '100%', mt: 1 }}>
                                <InputLabel>{labelText}</InputLabel>
                                <Select label={labelText} value={optionId} onChange={(e) => setOptionId(e.target.value)}>
                                    <MenuItem value="0">Use Rule</MenuItem>
                                    {optionsData.map((data, key) => (
                                        <MenuItem key={key} value={data.id}>
                                            {data.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {(option === 'upgrade' || option === 'license') && (
                        <Grid item sx={{ width: '100%', mt: 1 }}>
                            <FormControl sx={{ width: '100%', mt: 1 }}>
                                <InputLabel>{labelText}</InputLabel>
                                <Select label={labelText} value={defaultOption} onChange={(e) => setDefaultOption(e.target.value)}>
                                    {optionsData.map((data, key) => (
                                        <MenuItem key={key} value={data.id}>
                                            {data.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {option === 'policy' && (
                        <Grid item sx={{ width: '100%', mt: 1 }}>
                            <FormControl sx={{ width: '100%', mt: 1 }}>
                                <InputLabel>{labelText}</InputLabel>
                                <Select label={labelText} value={optionId} onChange={(e) => setOptionId(e.target.value)}>
                                    <MenuItem value="0">Use Rule</MenuItem>
                                    {optionsData.map((data, key) => (
                                        <MenuItem key={key} value={data.policyid}>
                                            {data.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {option === 'script' && (
                        <Grid item sx={{ width: '100%', mt: 1 }}>
                            <FormControl sx={{ width: '100%', mt: 1 }}>
                                <InputLabel>{labelText}</InputLabel>
                                <Select label={labelText} value={optionId} onChange={(e) => setOptionId(e.target.value)}>
                                    <MenuItem value="0">Use Script</MenuItem>
                                    {optionsData.map((data, key) => (
                                        <MenuItem key={key} value={data.id}>
                                            {data.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    )}
                    {(option === 'getLogFile' || option === 'getTISData') && <Grid item sx={{ mt: 1 }} />}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button style={{ fontWeight: optionId !== '0' ? 'bold' : 'normal' }} variant="outlined" onClick={onSubmit}>
                    {option === 'getLogFile' || option === 'getTISData' || option === 'script' ? 'Okay' : 'Save'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

RightClickOptionsDialog.propTypes = {
    onClose: PropTypes.func,
    option: PropTypes.string,
    devices: PropTypes.array,
    inputFields: PropTypes.object
};

export default RightClickOptionsDialog;
